import Slice from './Slice';
import SliceList from './list';
import SliceCta from './cta';
import SliceContent from './content';
import SliceIcon from './icon';
import SliceBody from './body';
import SliceImage from './image';
export { Slice, SliceList, SliceCta, SliceContent, SliceIcon, SliceBody, SliceImage };
//# sourceMappingURL=index.js.map